import React from 'react';
import {
    StyleSheet,
    TouchableOpacity,
    View,
    Image
} from 'react-native';
import { ODSIcon } from '../ODSIcon';
import { ODSText } from '../ODSText';
import getScreenType from '../../../utils/getScreenType';
import { useTheme } from '@emotion/react';
import ODSButton from '../ODSButton';

const ODSRentReadyTile = ({
    rentReadyData,
    onPress,
}) => {
    const theme = useTheme();
    const getIcon = (type) => {
        if (type == 2) {
            return (
                <Image source={require('../../../images/icons/dashboard/tick.png')} style={{ width: 20, height: 20 }} />
            )
        }
        else if (type == 1) {
            return (
                <ODSIcon color={theme.colors.feedback.warning[400]} icon="TB-Rotating" size={24} />
            )
        } else {
            return (
                <View style={{ width: 20, height: 20, borderRadius: 20, backgroundColor: theme.colors.disabled.text, justifyContent: 'center', alignItems: 'center' }}>
                    <ODSIcon color='white' icon="TB-Check" size={12} />
                </View>
            )
        }
    }

    return (
        <View style={[styles(theme.colors).containerStyle]}>
            <View style={{ padding: 24 }}>
                <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 8, justifyContent: 'space-between', alignItems: 'center' }}>
                    <ODSText type={getScreenType() == 'phone' ? 'h5' : 'h6'} color={theme.colors.text.black}>Rent Ready</ODSText>
                    <Image source={require('../../../images/icons/dashboard/rentready_pink.png')} style={{ width: 40, height: 40 }} />
                </View>
                <ODSText type={getScreenType() == 'phone' ? 'h6-light' : 'md'} color={theme.colors.text.black}>Be a more desirable tenant by using our pre-qualification tool.</ODSText>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: 24, marginBottom: 12 }}>
                    {rentReadyData.map((e, index) =>
                        <TouchableOpacity onPress={e.onPress} key={index} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', marginBottom: 16 }}>
                            {getIcon(e.state)}
                            <ODSText marginLeft={8} type='md' color={theme.colors.text.primary}>{e.title}</ODSText>
                        </TouchableOpacity>
                    )}
                </View>
                <ODSButton
                    restStyle={{ alignSelf: 'center' }}
                    type="primary"
                    disabled={false}
                    onPress={onPress}
                    themeColor={theme.colors.main.pink}
                >Go to Rent Ready</ODSButton>
            </View>
        </View>
    );
};

const styles = (theme) =>
    StyleSheet.create({
        containerStyle: {
            width: getScreenType() == "phone" ? "100%" : '100%',
            borderRadius: 12,
            borderColor: theme.main.pink[500],
            borderWidth: 1,
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center'
        },
        button: {
            height: 28,
            paddingHorizontal: 10,
            justifyContent: 'center',
            backgroundColor: theme.feedback.error[700],
            alignItems: 'center',
            borderRadius: 1000,
            shadowColor: '#101828',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 2,
            flexDirection: 'row',

        }
    });

export default ODSRentReadyTile;
